module.exports = __webpack_public_path__ + "static/media/S (59).e46bcb23.jpg";